import React, { forwardRef } from 'react';
import {
  FieldProps,
  InjectedFieldProps,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { Confirmation } from 'components/common';
import { RewardedActionDto } from '../../types';

type DeleteRewardActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardedActionDto;
};

const DeleteRewardActionField = forwardRef<HTMLLIElement, DeleteRewardActionFieldProps>(
  ({ record }, ref) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleDeleteAction = async () => {
      if (!record?.id) {
        return;
      }

      try {
        await dataProvider.delete('rewardsAction', { id: record.id });
        refresh();
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : 'Failed to delete rewards action';
        notify(message);
      }
    };

    return (
      <Confirmation title="Delete action" content="Are you sure you want to delete this action?">
        <MenuItem ref={ref} onClick={handleDeleteAction}>
          Delete
        </MenuItem>
      </Confirmation>
    );
  }
);

export default DeleteRewardActionField;
